<template>
  <article class="sh-messaging-empty-state">
    <button
      type="button"
      class="sh-messaging-empty-icon-circle"
      aria-label="Start a new message"
      @click="$emit('new-message')"
    >
      <i class="fal fa-message-medical" aria-hidden="true"></i>
    </button>
    <h3 class="sh-messaging-empty-title">Start a new message</h3>
    <div class="sh-messaging-empty-body">
      <p>
        Start a new message by choosing from one of your Rallies then
        select who you&rsquo;d like to message.
      </p>
    </div>
  </article>
</template>

<script>
  export default {
    emits: ['new-message']
  }
</script>
